import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import {LineHaulDetailContext} from "./context/LineHaulDetailContext";
import {LineHaulFilterContext} from "./context/LineHaulFilterContext";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import Table, {TableRow, TableCell} from "@amzn/meridian/table"
import {chainWalk, getSplitViewHeaders} from "../util/Util";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../util/RefreshTimer";
import {getFeaturesFromParent} from "../handler/ParentDataHandler";
import {ACTION_TYPE, FEATURES} from "../util/Constants";
import {ConfigContext} from "../global/context/ConfigContext";

const LineHaulContent = (props) => {
    const {filter} = useContext(LineHaulFilterContext)
    const {configDispatch, configViewModel} = useContext(ConfigContext)
    const {viewModel, dispatch} = useContext(LineHaulDetailContext)

    useEffect(() => {
        getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatus => {
            configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
        })
        const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);
        dispatch({
            type: 'LOAD_VIEW',
            data: {lineHaulId: props.lineHaul.lineHaulId, filter: filter, dispatcher: dispatch, isCPTFilterEnabled: isCPTFilterEnabled}
        });
    }, [filter.PackageSize, filter.EAD, filter.Cycle, filter.CPT, filter.Cluster, filter.OtherAttributes]);

    const isGroupedMetric = (groupedContainerMetrics) => {
        return groupedContainerMetrics &&
            (groupedContainerMetrics.doubleGroupedMetric || groupedContainerMetrics.singleGroupedMetric);
    };

    const getPackageListUrl = (containerId, packageState) => {
        return "#packageList/" + props.lineHaul.lineHaulId + "/" + containerId + "/" + packageState + "/" + filter + "/Receive"
    };

    return (
        <Column>
            <RefreshTimer deps={[viewModel]}/>
            <Row widths={["grid-12"]}>
                <Table showDividers={false} spacing="small" showStripes={false}>
                    <TableRow>
                        <TableCell columnSpan={1}>
                            <Text type="h100">
                                <FormattedMessage id="linehaul_detail.id" defaultMessage="ID"/>
                            </Text>
                        </TableCell>
                        <TableCell columnSpan={2}>
                            <Text type="h100">
                                <FormattedMessage id="linehaul_detail.type" defaultMessage="Type"/>
                            </Text>
                        </TableCell>
                        <TableCell columnSpan={7}>
                            <Text type="h100">
                                <FormattedMessage id="linehaul_detail.pending_induct" defaultMessage="Pending Induct"/>
                                / &nbsp;
                                <FormattedMessage id="linehaul_detail.total" defaultMessage="Total"/>
                            </Text>
                        </TableCell>
                    </TableRow>
                    {viewModel.details.map(detail => (
                        <TableRow highlightOnHover={isGroupedMetric(detail.groupedContainerMetrics)} key={detail.containerId} open={detail.open}
                                  onClick={isGroupedMetric(detail.groupedContainerMetrics) ?
                                      () => dispatch({type: 'EXPAND_CONTAINER_DATA', data: detail.containerId}) : null}>
                            <TableCell columnSpan={1}>
                                <Text type="h100">
                                    {detail.containerId}
                                   </Text>
                            </TableCell>
                            <TableCell columnSpan={2}>{detail.containerType}</TableCell>
                            <TableCell columnSpan={7}>
                                {detail.pendingInductVolume > 0 ?
                                    <Link href={getPackageListUrl(detail.containerId, "PENDING_INDUCT")}
                                          type="secondary">{detail.pendingInductVolume} </Link>
                                    : 0} / &nbsp;
                                {detail.volume}
                            </TableCell>
                            {detail.groupedContainerMetrics && detail.groupedContainerMetrics.doubleGroupedMetric &&
                            <TableRow>
                                <TableCell> </TableCell>
                                {Object.keys(getSplitViewHeaders(detail.groupedContainerMetrics.doubleGroupedMetric)).map(key => (
                                    <TableCell width={"150px"}>
                                        <Text type="h100">
                                            {key}
                                        </Text></TableCell>
                                ))}
                            </TableRow>
                            }
                            {detail.groupedContainerMetrics && detail.groupedContainerMetrics.singleGroupedMetric &&
                            <TableRow><TableCell> </TableCell></TableRow>
                            }
                            {detail.groupedContainerMetrics && detail.groupedContainerMetrics.doubleGroupedMetric && Object.entries(detail.groupedContainerMetrics.doubleGroupedMetric).map(([key, value]) => (
                                <TableRow>
                                    <TableCell header={true} width={"150px"}>
                                        <Text type="h100">
                                            {key}
                                        </Text>
                                    </TableCell>
                                    {Object.values(value).map(volume => (
                                        <TableCell
                                            width={"150px"}> {volume['PENDING_INDUCT']} / &nbsp; {volume['ALL']}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                            {detail.groupedContainerMetrics && detail.groupedContainerMetrics.singleGroupedMetric &&
                            Object.entries(detail.groupedContainerMetrics.singleGroupedMetric).map(([key, value]) => (
                                <TableRow>
                                    <TableCell header={true} width={"150px"}>
                                        <Text type="h100">
                                            {key}
                                        </Text>
                                    </TableCell>
                                    <TableCell
                                        width={"150px"}> {value['PENDING_INDUCT']} / &nbsp; {value['ALL']}</TableCell>
                                </TableRow>
                            ))}
                        </TableRow>
                    ))}
                </Table>
            </Row>
        </Column>
    )
}

export default LineHaulContent


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHaulContent.js